import { render } from "./SingIn.vue?vue&type=template&id=06c63299&scoped=true"
import script from "./SingIn.vue?vue&type=script&lang=js"
export * from "./SingIn.vue?vue&type=script&lang=js"

import "./SingIn.vue?vue&type=style&index=0&id=06c63299&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06c63299"

export default script